module.exports = __webpack_public_path__ + "img/roleChange.c6a01634.svg";